import React from 'react';
// import Nav from './Nav';
import { Outlet } from 'react-router';
// import Nav from './Nav';
import Navbar from '../components/Navbar';

export default function PostLogin() {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}